<div *ngIf="this.loader.getLoading()" class="cssload-container">

    <div class="loader"></div>
<!--     <span class="messaggio">{{loadMessagge()}}</span> -->

</div>
